import { defineStore } from 'pinia';
import type { ILineItemStore } from '../types/store-states.types';
import { E_SCENARIO, type ILineItemUpdate } from '../types/line-item.types';
import LineItemModel from '../models/line-item.model';
import { useEditorStore } from './editor.store';

export const useLineItemStore = defineStore('au-line-item', {
  state: () => ({
    lineItem: null,
  } as ILineItemStore),
  
  getters: {
    getLineItem: (state) => {
      if (state.lineItem?.scenario === E_SCENARIO.VDP) {
        const countRows = useEditorStore().getCountRowsVdp;
        if (!countRows) {
          state.lineItem.scenario = E_SCENARIO.DEFAULT;
        }
      }
      return state.lineItem;
    },
  },

  actions: {
    updateLineItem(lineItem: ILineItemUpdate) {
      if (!this.lineItem) {
        this.lineItem = new LineItemModel();
      };

      if (lineItem?.key) this.lineItem.key = lineItem.key;

      if (lineItem?.originalProductId) this.lineItem.originalProductId = lineItem.originalProductId;
      if (lineItem?.originalProductId) this.lineItem.properties._hidden.originalProductId = lineItem.originalProductId;

      if (lineItem?.originalProductUrl) this.lineItem.originalProductUrl = lineItem.originalProductUrl;
      if (lineItem?.originalProductUrl) this.lineItem.properties._hidden.originalProductUrl = lineItem.originalProductUrl;

      if (lineItem?.sku) this.lineItem.sku = lineItem.sku;
      if (lineItem?.sku) this.lineItem.properties._hidden.sku = lineItem.sku;

      if (lineItem?.quantity) this.lineItem.quantity = lineItem.quantity;

      if (lineItem?.fields) this.lineItem.properties._fields = lineItem.fields;

      if (lineItem?.resources) this.lineItem.properties._resources = lineItem.resources;
      
      if (lineItem?.stateId) this.lineItem.properties._stateId = lineItem.stateId;
      
      if (lineItem?.userId) this.lineItem.properties._userId = lineItem.userId;
      
      if (lineItem?.images) this.lineItem.properties._hidden.images = lineItem.images;

      if (lineItem?.countRowsVdp) this.lineItem.countRowsVdp = lineItem.countRowsVdp;

      if (lineItem?.scenario) this.lineItem.scenario = lineItem.scenario;

      if (lineItem?.productVariantId) this.lineItem.productVariantId = lineItem.productVariantId;
    },
  },
});
